module.exports = __webpack_public_path__ + "static/img/brand_7.bc97d9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/brand_7.jpg
// module id = gsLv
// module chunks = 1